import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import TabsTungee from '@/components/TabsTungee/index.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import baseMessage from '@/views/yuntuSales/customerCenter/components/baseMessage.vue'
import ViewFooterBtn from '@/views/yuntuSales/customerCenter/components/viewFooterBtn.vue'
import tabsBusiness from '@/views/yuntuSales/customerCenter/components/tabsBusiness.vue'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
import { useRoute } from 'vue-router'
import { addToFav, cancelToFav } from '@/api/common'

const __default__ = {
  name: 'LbuClientsView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const tungeeRef = ref()
const activeKey = ref('base')
const contactsRef = ref()
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
onMounted(() => {
  fetch()
})
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    operationLogRef.value?.fetch()
  }
}
const footerSuccess = (tag: 'base' | 'contact' | 'tungee') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  } else if (tag === 'tungee') {
    tungeeRef.value?.fetch()
  }
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_lbu',
    cosId: data.value.customerInfo.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = data.value.customerInfo.cosId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: data.value.customerInfo.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = null
      data.value.collectionTime = null
    }
  })
}
const permissionBasic = {
  transfer: 'lbu_clients_transfer_btn',
  visitor_add: 'lbu_clients_visitor_add_btn',
  edit: 'lbu_clients_edit_btn',
  follow_add: 'lbu_clients_follow_add_btn',
  buss_add: 'lbu_clients_buss_add_btn',
  concat_add: 'lbu_clients_concat_add_btn'
}
const permissionFollow = {
  edit: 'lbu_clients_follow_edit_btn',
  del: 'lbu_clients_follow_del_btn'
}
const permissionBuss = {
  edit: 'lbu_clients_buss_edit_btn',
  del: 'lbu_clients_buss_del_btn'
}
const permissionConcat = {
  edit: 'lbu_clients_concat_edit_btn',
  del: 'lbu_clients_concat_del_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, {
            header: "",
            title: data.value?.customerInfo?.customerName,
            sellerName: data.value?.customerInfo?.sellerName,
            "collection-id": data.value?.collectionId,
            customLabel: "联系人姓名",
            customValue: data.value?.contact?.name,
            "add-fav": addFavorite,
            "cancel-fav": cancelFavorite
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                onChange: changeTabs,
                activeKey: activeKey.value,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "base",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        perfect: true,
                        data: data.value,
                        isEdit: false,
                        type: "clients",
                        content: ['customerInfo', 'business'],
                        permissionPage: permissionBasic,
                        view: ""
                      }, null, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "contact",
                    tab: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        ref_key: "contactsRef",
                        ref: contactsRef,
                        appId: "cos_lbu",
                        contactRefId: _unref(route).query.cosId,
                        permissionPage: permissionConcat
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: "跟进记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsClueCosFollowUp), {
                        appId: "cos_lbu",
                        showFooter: true,
                        followRefId: _unref(route).query.cosId,
                        permissionPage: permissionFollow
                      }, null, 8, ["followRefId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    tab: "商机"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsBusiness, { permissionPage: permissionBuss })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "6",
                    tab: "转化记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsConversion), {
                        resourceId: _unref(route).query.cosId,
                        appId: "cos_lbu"
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "operationLog",
                    tab: "操作日志"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        ref_key: "operationLogRef",
                        ref: operationLogRef,
                        tableId: "LbuClientsOperationLog",
                        appId: "cos_lbu",
                        resourceId: _unref(route).query.cosId
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "tungeeInfo",
                    tab: "探迹信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsTungee, {
                        appId: "cos_lbu",
                        ref_key: "tungeeRef",
                        ref: tungeeRef,
                        cosId: _unref(route).query.cosId,
                        customerName: data.value?.customerInfo?.customerName
                      }, null, 8, ["cosId", "customerName"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          }, 8, ["title", "sellerName", "collection-id", "customValue"]),
          _createVNode(ViewFooterBtn, {
            permissionPage: permissionBasic,
            onSuccess: footerSuccess,
            loading: loading.value,
            type: "clients",
            workCode: data.value?.customerInfo?.seller,
            customerName: data.value?.customerInfo?.customerName
          }, null, 8, ["loading", "workCode", "customerName"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})